import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasAppAccess } from '../helpers/subscription.helpers';

/**
 * Requires subscription/trial access after auth (Build Plan §3).
 */
const SubscriptionGuard = ({ access, synced, children }) => {
  const location = useLocation();

  if (!synced) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f5f5f5',
        }}
      >
        <div className="text-center">
          <div className="spinner-border text-success" role="status" />
          <p className="mt-3 text-muted mb-0">Checking access...</p>
        </div>
      </div>
    );
  }

  if (!hasAppAccess(access)) {
    return <Redirect to={{ pathname: '/subscription', state: { from: location } }} />;
  }

  return children;
};

SubscriptionGuard.propTypes = {
  access: PropTypes.object,
  synced: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

SubscriptionGuard.defaultProps = {
  access: null,
  synced: false,
};

const mapStateToProps = (state) => ({
  access: state.subscription.access,
  synced: state.subscription.synced,
});

export default connect(mapStateToProps)(SubscriptionGuard);
